import { apiGet, apiPost, apiDelete } from './api.service';

export async function storeKeys(params) {
  return await apiPost('/users/keys', params);
}

export async function getKeys() {
  return await apiGet('/users/keys');
}

export async function getKey(keyId) {
  return await apiGet(`/users/keys/${encodeURIComponent(keyId)}`);
}

export async function getActiveKey() {
  return await apiGet('/users/keys/active');
}

export async function deleteKey(keyId) {
  return await apiDelete(`/users/keys/${encodeURIComponent(keyId)}`);
}

export async function getPublicKey(email) {
  return await apiGet(`/users/keys/public/${email}`);
}

export async function updateKey(keyId, updates) {
  return await apiPost(`/users/keys/${encodeURIComponent(keyId)}`, { ...updates });
}